export const ORDER_MILESTONES = {
    ORDER_PLACED: 'order_placed',
    SCHEDULING: 'scheduling',
    PRODUCTION: 'production',
    INSPECTION: 'inspection',
    DELIVERY_ORDER: 'deliveryOrder',
    SHIPPING: 'shipping',
    CUSTOMER_DELIVERY: 'customerDelivery',
}

export const ORDER_MILESTONE_TITLES = {
    [ORDER_MILESTONES.ORDER_PLACED]: 'Order placed',
    [ORDER_MILESTONES.SCHEDULING]: 'Schedule MP by',
    [ORDER_MILESTONES.PRODUCTION]: 'Fictiv dock date',
    [ORDER_MILESTONES.INSPECTION]: 'Fictiv QC by',
    [ORDER_MILESTONES.DELIVERY_ORDER]: 'Shipment release by',
    [ORDER_MILESTONES.SHIPPING]: 'Carrier pickup by',
    [ORDER_MILESTONES.CUSTOMER_DELIVERY]: 'Customer delivery date',
}

export const MILESTONE_NOT_REACHED = 'Milestone not reached'
export const MILESTONE_MISSED = 'Milestone date missed'
export const YEAR_FIRST_DATE_FORMAT = 'YYYY-MM-DD, HH:mm z'
export const MONTH_FIRST_DATE_FORMAT = 'MM/DD/YYYY, HH:mm z'
